<template>
  <div id="footer">
    <ContactCard id="contact"></ContactCard>
    <IconBar :dark="true" id="icon-bar"></IconBar>
    <!-- <CopyrightCard id="copyright"></CopyrightCard> -->
  </div>
</template>

<script>
import ContactCard from "@/components/ContactCard.vue";
import IconBar from "@/components/IconBar.vue";
// import CopyrightCard from "@/components/CopyrightCard.vue";

export default {
  components: {
    ContactCard,
    IconBar,
    // CopyrightCard,
  },
  props: {
    layered: Boolean,
  },
};
</script>

<style scoped>
#footer {
  color: hsla(0, 0%, 100%, 0.8);
  position: relative;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.8);
}

#contact {
  padding: 50px;
}

#copyright {
  margin-top: 40px;
}

#icon-bar {
  padding: 20px;
}

#footer {
  padding-bottom: 10px;
}

#padding {
  margin: 40px;
}
</style>
